import axios from "axios";
import { store } from "../../store";

export async function createAdminAction() {
  const token =
    sessionStorage.getItem("token") ?? localStorage.getItem("token");

  const { email } = store.getState().user;
  const dataToSend = {
    email,
  };

  return await axios
    .post(
      `${process.env.REACT_APP_API_ORIGIN}/1.0.0/cms/users/create`,
      dataToSend,
      {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      }
    )
    .then((res) => res.data);
}
